import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa516dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-flex-row tw-items-center" }
const _hoisted_3 = { class: "tw-flex tw-justify-around tw-items-center tw-w-full" }

import SearchIcon from "@/components/svgs/searchIcon.vue";
import { ref, watch } from "vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'baseSearchbox',
  props: {
  /** The model and value of the input */
  modelValue: { type: null, required: true },
  inputStyle: { type: String, required: false, default: "" },
  iconSearchStyle: { type: String, required: false, default: "" },
  iconCloseStyle: { type: String, required: false, default: "" },
  placeholder: {
    type: String,
    required: false,
    default: getComponentUiText("app-header-search-prompt-1"),
  },
  inputSearch: { type: String, required: false, default: "" },
  id: { type: String, required: false, default: "" },
},
  emits: ["update:modelValue", "on:focus", "on:blur"],
  setup(__props, { emit }) {

const props = __props;





let currentValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    currentValue = ref(props.modelValue);
  },
);

const handleInput = (val: string) => {
  emit("update:modelValue", currentValue.value);
};

const handleFocus = () => {
  emit("on:focus");
};

const handleBlur = () => {
  emit("on:blur");
};

const clearData = () => {
  currentValue.value = "";
  emit("update:modelValue", currentValue.value);
};

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!

  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "tw-flex tw-items-center"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchIcon, {
        size: 15,
        color: "#B7B7B7",
        "svg-class": __props.iconSearchStyle
      }, null, 8, ["svg-class"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BFormInput, {
        id: __props.inputSearch,
        modelValue: _unref(currentValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentValue) ? (currentValue).value = $event : currentValue = $event)),
        type: "text",
        placeholder: __props.placeholder,
        class: _normalizeClass(["input-search tw-border-none tw-outline-none tw-ml-[9px] !tw-p-0 tw-text-[14px] tw-text-[#211f58]", __props.inputStyle]),
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur
      }, null, 8, ["id", "modelValue", "placeholder", "class"]),
      (_unref(currentValue) !== '')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "tw-bg-transparent tw-border-none tw-outline-none",
            onClick: clearData
          }, [
            _createVNode(CloseBoxIcon, {
              size: 15,
              color: "#DBDBDB",
              "svg-class": __props.iconCloseStyle
            }, null, 8, ["svg-class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})